var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yx-center"},[_c('div',[_vm._v("4 0 1")]),_c('div',[_vm._v("您没有权限进入此页面")]),_c('el-button',{staticStyle:{"margin-top":"30px"},attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }